// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  captchaSiteKey: '6LdD3MUUAAAAAPfIdwntSfgwi2ZEL6pATff6VGFg',
  // apiURL: 'https://services.latam-yacare-core-nonprod.aws.fisv.cloud/qr-latam-core/api',
  apiURL: 'https://pix-cat.fiservapp.com/qr-latam-core/api',
  urlWeb: 'http://localhost:8080/#/',
  oneSignalAppId: '97e0b142-c892-481e-bd05-b567fc0305d8',
  googleMapsKey: '',
  throttledRefreshBalance: 5, //minutes
  sessionExpirationTime: 21600, //seconds
  encryptKey: 'YK123car2k',
  resend2FA: 10, //seconds
  pixStatusMaxAttempts: 10,
  pixStatusInterval: 7000, //miliseconds
  timeoutMs: 10000, //miliseconds
  version: require('../../package.json').version,
  pixPhonePrefix: '+549',
  pixPhoneRegex: /^[0-9]{10}$/,
  pixPhoneMask: '',
  pixPhoneHint: '',
  minDate: '01-01-2024',
  baseUrlPingId: 'https://br-ssoca-dev.1dc.com'
};
